module.exports = __webpack_public_path__ + "static/media/questionLogo.e5a6ed3c.svg";